import { walletRecordOf } from '../../util/walletRecords';

// Which work authorisation answers on a candidate's profile a verified document matched. These
// ticks are the candidate's own record, kept in their listing's private data, so they are shown
// only when the viewed listing is the viewer's own profile listing, and taken from the viewer's
// copy of it (which carries that private data). Everyone else gets none and relies on the overall
// work authorisation badge.
export const workTicksFor = (currentListing, ownProfileListing) => {
  const ownId = ownProfileListing?.id?.uuid;
  if (!ownId || currentListing?.id?.uuid !== ownId) return {};
  return walletRecordOf(ownProfileListing.attributes, 'workChecks') || {};
};
